const num = (v) => Number(v || 0);
const fmt = (v, d = 2) =>
  v === null || v === undefined || v === ""
    ? "-"
    : num(v).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });

/* คอลัมน์ทั้งหมด — เรียงตามไฟล์ Excel ต้นฉบับ (ตัดคอลัมน์พาเลตออก)
   ผู้ใช้ลากสลับลำดับ / ซ่อน-แสดงได้จากหน้าจอ */
export const ALL_COLUMNS = [
  { key: "seq",         title: "ลำดับ",              width: 65,  align: "center", type: "text" },
  { key: "customer",    title: "Customer",           width: 160, align: "left",   type: "text" },
  { key: "item_code",   title: "Item Code",          width: 130, align: "left",   type: "text" },
  { key: "description", title: "Description",        width: 240, align: "left",   type: "text" },
  { key: "packing",     title: "packing",            width: 120, align: "center", type: "text" },
  { key: "nw_unit",     title: "nw/unit",            width: 100, align: "right",  type: "num", digits: 3 },
  { key: "w_cm",        title: "W cm",               width: 80,  align: "right",  type: "num", digits: 2 },
  { key: "l_cm",        title: "L cm",               width: 80,  align: "right",  type: "num", digits: 2 },
  { key: "h_cm",        title: "H cm",               width: 80,  align: "right",  type: "num", digits: 2 },
  { key: "m3_cs",       title: "M3/cs",              width: 110, align: "right",  type: "num", digits: 6 },
  { key: "m3_round",    title: "Round Figure M3/cs", width: 130, align: "right",  type: "num", digits: 3 },
  { key: "nw_cs",       title: "NW kg/cs",           width: 100, align: "right",  type: "num", digits: 2 },
  { key: "gw_cs",       title: "GW kg/cs",           width: 100, align: "right",  type: "num", digits: 2 },
  { key: "order_cs",    title: "order c/s",          width: 100, align: "right",  type: "num", digits: 0 },
  { key: "total_nw",    title: "total NW kg",        width: 120, align: "right",  type: "num", digits: 2 },
  { key: "total_gw",    title: "total GW kg",        width: 120, align: "right",  type: "num", digits: 2 },
  { key: "total_cbm",   title: "total cbm",          width: 110, align: "right",  type: "num", digits: 3 },
];

/* คอลัมน์ที่ต้องรวมยอดท้ายตาราง */
export const SUM_KEYS = ["order_cs", "total_nw", "total_gw", "total_cbm"];

export const DEFAULT_VISIBLE = ALL_COLUMNS.map((c) => c.key);

/* แปลง config → columns ของ antd Table */
export const buildColumns = (orderedKeys, visibleKeys) =>
  orderedKeys
    .filter((k) => visibleKeys.includes(k))
    .map((k) => {
      const c = ALL_COLUMNS.find((x) => x.key === k);
      if (!c) return null;
      return {
        key: c.key,
        dataIndex: c.key,
        title: c.title,
        width: c.width,
        align: c.align,
        ellipsis: c.type === "text",
        render:
          c.type === "num"
            ? (v) => (num(v) === 0 && c.key !== "order_cs" ? "-" : fmt(v, c.digits))
            : undefined,
      };
    })
    .filter(Boolean);

export { num, fmt };
